import { FC, useMemo } from "react";
import { Schedule } from "types";
import { BaseFormValues, RepeatOption } from "@/components/Product/SchedulesAvailability/ScheduleEditor";

export interface ScheduleEditorSlots {
    /** Content to be displayed "before" main form */
    Prefix: FC;

    /** Content to be displayed "after" main form */
    Suffix: FC;

    /** If provided, the main form would be overwritten */
    Content: FC;
}

export interface ScheduleEditorSlotsProps<FormValues = BaseFormValues> {
    values?: Schedule & FormValues;

    /** Used to customize the `ScheduleEditor` content and components */
    slots?: Partial<ScheduleEditorSlots>;

    /** Used to add extra options for "Dates" form-field. Ex, "Relative to Purchase Date" */
    repeatOptions?: RepeatOption[];
}

export const useScheduleEditorSlots = ({ values, slots, repeatOptions }: ScheduleEditorSlotsProps) => {
    return useMemo(() => {
        const option = repeatOptions?.find((option) => option.value === values?.repeat);

        const getComponent = (name: keyof ScheduleEditorSlots): FC | null =>
            option?.slots?.[name] ?? slots?.[name] ?? null;

        return {
            Prefix: getComponent("Prefix"),
            Suffix: getComponent("Suffix"),
            Content: getComponent("Content"),
        };
        /* eslint-disable-next-line react-hooks/exhaustive-deps -- we don't want to listen on complete `slots` object but on the children element to reduce re-renderings */
    }, [values?.repeat, repeatOptions, slots?.Prefix, slots?.Suffix, slots?.Content]);
};
